import { track, logError } from '@tracking';
import { categoryType } from '@services/routes.service';

const EVENT_NAME = 'favorites.clicked';

const TRACKING_ACTION = {
  ADD: 'add',
  DELETE: 'delete',
};

const trackFavoritesClicked = ({ shopId, isAddingToFavorites = true }) => {
  try {
    const { location } = window;

    const favoriteOrigin = categoryType(location);
    const favoriteAction = isAddingToFavorites
      ? TRACKING_ACTION.ADD
      : TRACKING_ACTION.DELETE;

    const payload = {
      shopId,
      favoriteOrigin,
      favoriteAction,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackFavoritesClicked;
